import * as React from 'react';
import { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import VoxelAutocomplete, { GenericOption } from '../../voxel/Forms/VoxelAutocomplete';

export interface ImportTagGroupAutocompleteProps {
  selectedProject: Partial<ProjectGq>;
  setSelectedTagGroups: Dispatch<SetStateAction<number[]>>;
  selectedTagGroups: number[];
  disabled: boolean;
}

const ImportTagGroupAutocomplete: React.FC<ImportTagGroupAutocompleteProps> = ({
  selectedProject,
  setSelectedTagGroups,
  selectedTagGroups,
  disabled,
}) => {
  const projectQuery = projectsApiService.queries.useGetProject(
    {
      id: !selectedProject?.tagImportProject ? selectedProject?.id : undefined, // We skip the ID so that external users can fetch the data...
      tagImportProject: selectedProject?.tagImportProject,
    }, { skip: !selectedProject?.id }
  );

  const tagGroupList = useMemo(() => projectQuery?.result?.tagGroups ?? [], [projectQuery?.result?.tagGroups]);

  const options: GenericOption[] = useMemo(() => {
    if (!tagGroupList.length) return [];
    return tagGroupList?.map((x) => ({ value: x.id, title: x.name })) ?? [];
  }, [tagGroupList]);

  return (
    <>
      <VoxelAutocomplete
        label='Tag groups'
        labelPosition='top'
        multi
        placeholder='Select tag groups'
        options={options}
        selectedOptionValues={selectedTagGroups}
        setSelectedOptions={(options: GenericOption[]) => setSelectedTagGroups(options.map((opt) => opt.value))}
        disabled={disabled}
      />
    </>
  );
};

export default ImportTagGroupAutocomplete;
